import { useFormikContext } from "formik"
import { makeStyles } from "tss-react/mui"
import { FormikTextField } from "../../../../../../shared/components/forms/Formik"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { CompanyFormValues } from "../companyTypes"
import { AgreementOwnerContent } from "../../components/form/AgreementOwnerContent"
import { AddressContent } from "../../components/form/AddressContent"
import { ContactDetailsContent } from "../../components/form/ContactDetailsContent"
import { InvoiceDetailsContent } from "../../components/form/InvoiceDetailsContent"
import { EntityTypeSelect } from "../../components/form/EntityTypeSelect"
import { AgreementOptions, EntityHistory } from "../../supportEntitiesTypes"
import { EntityHistoryAccordion } from "../../components/EntityHistoryAccordion"
import { CompanySettingsAccordion } from "./CompanySettingsAccordion"
import { CompanySelfSignUpAccordion } from "./CompanySelfSignUpAccordion"
import { StandardForm } from "../../../../../../shared/components/forms/StandardForm"
import { StandardSidePanel } from "../../../../../../shared/components/forms/StandardSidePanel"
import { StandardMainPanel } from "../../../../../../shared/components/forms/StandardMainPanel"

const useStyles = makeStyles()((theme) => ({
    textField: {
        width: "50%",
    },
}))

export function CompanyCreateUpdateContent({
    history,
    selfSignupUrl,
}: {
    history?: EntityHistory
    selfSignupUrl?: string
}) {
    const { classes } = useStyles()

    const { values, setFieldValue } = useFormikContext<CompanyFormValues>()

    return (
        <StandardForm>
            <StandardMainPanel>
                <AgreementOwnerContent />
            </StandardMainPanel>
            <StandardMainPanel>
                <EntityTypeSelect />

                <LocalizedStrict id="support-create-company-company-number-label" attrs={{ label: true }}>
                    <FormikTextField<CompanyFormValues>
                        name="businessNumber"
                        label="Company number"
                        className={classes.textField}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="support-create-company-main-ean-number-label" attrs={{ label: true }}>
                    <FormikTextField<CompanyFormValues>
                        name="mainEanNumber"
                        label="Main EAN number"
                        className={classes.textField}
                    />
                </LocalizedStrict>
                <LocalizedStrict id="support-create-company-company-name-label" attrs={{ label: true }}>
                    <FormikTextField<CompanyFormValues> name="name" label="Company name" fullWidth />
                </LocalizedStrict>

                <AddressContent />
            </StandardMainPanel>
            <StandardMainPanel>
                <ContactDetailsContent />
            </StandardMainPanel>
            {values.isSystemOwner === AgreementOptions.YES && (
                <StandardMainPanel>
                    <InvoiceDetailsContent />
                </StandardMainPanel>
            )}
            <LocalizedStrict id="support-create-company-aside-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <CompanySettingsAccordion />
                </StandardSidePanel>
            </LocalizedStrict>
            <LocalizedStrict id="support-create-company-aside-is-self-sign-up" attrs={{ title: true }}>
                <StandardSidePanel
                    title="Self sign-up"
                    variant="switchable"
                    checked={!!values.isSelfSignUp}
                    onCheckChange={(checked) => {
                        setFieldValue("isSelfSignUp", checked)
                    }}
                >
                    <CompanySelfSignUpAccordion url={selfSignupUrl} />
                </StandardSidePanel>
            </LocalizedStrict>
            {history && (
                <LocalizedStrict id="support-create-entity-aside-history" attrs={{ title: true }}>
                    <StandardSidePanel variant="collapsible" title="History">
                        <EntityHistoryAccordion history={history} />
                    </StandardSidePanel>
                </LocalizedStrict>
            )}
        </StandardForm>
    )
}
